// extracted by mini-css-extract-plugin
export default {"Blankslate":"archive-empty-states-module__Blankslate--aHqDq","Octicon":"archive-empty-states-module__Octicon--kqM14"};